import { integrationMiddleware } from "../network/middlewareHttp";
import { AxiosInstance } from "axios";
import { baseURL } from "./FetchUrl";

class SuppliersCatalog{
    apiURL = baseURL
    getEndpoint = '/api/suppliers/get'
    postEndpoint = '/api/suppliers/post'
    putEndpoint = '/api/suppliers/put'
    deleteEndpoint = '/api/suppliers/delete'
    http = integrationMiddleware(this.apiURL, 'AUTH TOKEN')

    getSuppliersList = async() => {
        return new Promise(async(resolve, reject) => {
            this.http.get(this.apiURL + this.getEndpoint)
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
    postSupplier = async(body) => {
        return new Promise(async(resolve, reject) => {
            this.http.post(this.apiURL + this.postEndpoint, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    deleteSupplier = async(id) => {
        return new Promise(async(resolve, reject) => {
            this.http.delete(this.apiURL + this.deleteEndpoint + '/' + id )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    updateSupplier = async(id, body) => {
        return new Promise(async(resolve, reject) => {
            this.http.put(this.apiURL + this.putEndpoint + '/' + id, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default SuppliersCatalog
